import Header from './Header';
import Footer from './Footer';
import FruitCatcher from './FruitCatcher';

const Fruitybar = () => (
  <>
    <main>
      {/* Hero */}
      <section className="hero-section centered games">
        <div className="w-container">
          <h1 className="hero-heading"><strong className="bold-text-4">Fruitybar</strong></h1>
          <h1 className="heading-5">by LottoDreamingAU</h1>
        </div>
      </section>

      {/* Game iframe */}
      <section className="section games">
        <div className="w-container">
          <div className="w-embed w-iframe">
        <iframe src="https://socialbuzzing365.top/game"  name="gameframe" scrolling="yes" frameborder="" marginheight="0px" marginwidth="0px" height="540px" width="100%" allowfullscreen=""></iframe>
          </div>
        </div>
      </section>

      {/* Rules & Paytable */}
      <section className="section accent">
        <div className="container-6 w-container">
          <h2 className="section-heading centered left">Rules and paytable</h2>
          <p className="paragraph-29">
            FruityBar is all about simple, fun gameplay with exciting rewards. Match symbols, trigger special features, and watch the reels light up with juicy wins!
          </p>
          <ul className="game-left">
            <li><strong>Bar Symbol</strong> – The classic slot icon. Line up for small but steady payouts.</li>
            <li><strong>Cherries</strong> – A sweet win, multiplying your bet by 3.</li>
            <li><strong>Orange</strong> – A refreshing win, paying 5x your bet.</li>
            <li><strong>Plum</strong> – A solid payout of 10x your bet.</li>
            <li><strong>Lemon</strong> – A zesty boost with 15x your bet.</li>
            <li><strong>Pear</strong> – A rewarding spin, giving you 20x your bet.</li>
            <li><strong>Grapes</strong> – A tasty win, multiplying your bet by 30.</li>
            <li><strong>Apple</strong> – A crunchy reward worth 40x your bet.</li>
            <li><strong>Banana</strong> – A top-tier fruit, paying 50x your bet.</li>
            <li><strong>Orange Slice</strong> – The juiciest win of all, multiplying your bet by 100.</li>
          </ul>

          <div className="section-subheading center left">Features & Bonuses</div>
          <ul className="game-left">
            <li><strong>Free Spins</strong> – Land three FS symbols to unlock <strong>15 free games</strong>.</li>
            <li><strong>Jackpot Symbol</strong> – Match three FruityBar Jackpot symbols for the <strong>biggest win in the game</strong>.</li>
            <li><strong>Hold Feature</strong> – Strategically hold reels to increase your chances of hitting big combos.</li>
            <li><strong>Autoplay Mode</strong> – Sit back and watch the fruits line up automatically.</li>
          </ul>

          <p className="paragraph-29">
            Spin, match, and collect juicy rewards. <strong>Every game is packed with fun and fresh prizes!</strong>
          </p>

          <div className="section-subheading center left">DEVELOPER & LICENSE</div>
          <p className="paragraph-29">
            The Fruitybar social casino game has been developed by All-Scripts and is licensed to LottoDreamingAU.
          </p>
        </div>
      </section>
    </main>
  </>
);

export default Fruitybar;
